import { slugs, pages } from '@kit/utils/APIV1'

export const routes = [
  {
    name: 'root',
    path: '/',
    component: () => import(/* webpackChunkName: "root" */'@pages/Home.vue'),
  },
  {
    name: 'locations',
    path: '/locations/:slug',
    component:() => import(/* webpackChunkName: "locations" */'@pages/Location.vue'),
    meta: {
      sitemap: {
        slugs: async() => {
          return await slugs('locations')
        }
      }
    }
  },
  {
    name: 'health-services',
    path: '/services/:id',
    component:() => import(/* webpackChunkName: "health-services" */'@pages/HealthServices.vue'),
    meta: {
      paramsMappedToMultipleSections:true,
      sitemap: {
        slugs: async() => {
          return await slugs('health-services')
        }
      }
    }
  },
  {
    name: 'job-openings',
    path: '/job-openings/:page?/:b64SortInfo?',
    component:() => import(/* webpackChunkName: "job-openings" */'@pages/JobOpenings.vue'),
    meta: {
      paramsMappedToMultipleSections:true,
      sitemap: {
        slugs: async() => {
          return await pages('job-openings')
        }
      }
    }
  },
  {
    name: 'job',
    path: '/job-openings/job/:id',
    component:() => import(/* webpackChunkName: "job" */'@pages/Job.vue'),
    meta: {
      sitemap: {
        slugs: async() => {
          return await slugs('job-openings')
        }
      }
    }
  },
  {
    name: 'team',
    path: '/team/:slug',
    component:() => import(/* webpackChunkName: "team" */'@pages/Team.vue'),
    meta: {
      sitemap: {
        slugs: async() => {
          return await slugs('teams')
        }
      }
    }
  },
  {
    name: 'staff-member',
    path: '/staff-member/:id',
    component: () => import(/* webpackChunkName: "staff_member" */'@pages/StaffMember.vue'),
    meta: {
      sitemap: {
        slugs: async() => {
          return await slugs('staff_members')
        }
      }
    }
  },
  { 
    name: 'about-us',
    path: '/about-us',
    component: () => import(/* webpackChunkName: "about-us" */'@pages/AboutUs.vue')
  },
  { 
    name: 'contact-us',
    path: '/contact-us',
    component: () => import(/* webpackChunkName: "contact-us" */'@pages/ContactUs.vue')
  },


  // {
  //   name: 'news',
  //   path: '/news/:page?',
  //   component: () => import(/* webpackChunkName: "news" */'@pages/NewsStories.vue'),
  //   meta: {
  //     sitemap: {
  //       slugs: async() => {
  //         return await pages('news-stories')
  //       }
  //     }
  //   }
  // },
  {
    name: 'news',
    path: '/news/:page?/:b64SortInfo?',
    component:() => import(/* webpackChunkName: "news" */'@pages/NewsStories.vue'),
    meta: {
      paramsMappedToMultipleSections:true,
      sitemap: {
        slugs: async() => {
          return await pages('news-stories')
        }
      }
    }
  },

  {
    name: 'news-story',
    path: '/news/story/:slug',
    component: () => import(/* webpackChunkName: "news-story" */'@pages/NewsStory.vue'),
    meta: {
      sitemap: {
        slugs: async() => {
          return await slugs('news-stories')
        }
      }
    }
  },

  {
    name: 'star',
    path: '/star',
    component: () => import(/* webpackChunkName: "star" */'@pages/STAR.vue'),
  },

  {
    name: 'covid-19',
    path: '/covid-19',
    component: () => import(/* webpackChunkName: "covid-19" */'@pages/Covid19.vue')
  },

]
